import React from 'react';
import { Check, Minus } from 'lucide-react';

interface PricingSectionProps {
  onStartClick: () => void;
}

const features = [
  { name: 'Grabaciones ilimitadas', free: true, book: true },
  { name: 'Transcripción automática', free: true, book: true },
  { name: 'Libro digital (memorias)', free: true, book: true },
  { name: 'Libro físico tapa dura', free: false, book: true },
];

const PricingSection: React.FC<PricingSectionProps> = ({ onStartClick }) => {
  return (
    <section className="py-8 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-6 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-stone-900 mb-4">
            Descubre gratis. Sin límites.
          </h2>
        </div>

        <div className="max-w-3xl mx-auto grid md:grid-cols-2 gap-6">
          {/* Free plan */}
          <div className="rounded-2xl border-2 border-stone-200 p-6 md:p-8 bg-white">
            <h3 className="text-xl font-semibold text-stone-900 mb-1">Gratis</h3>
            <p className="text-stone-500 text-sm mb-6">Todo incluido, para siempre</p>

            <ul className="space-y-4 mb-8">
              {features.map((f, i) => (
                <li key={i} className="flex items-center gap-3 text-sm text-stone-700">
                  {f.free ? (
                    <Check size={18} className="text-emerald-500 shrink-0" />
                  ) : (
                    <Minus size={18} className="text-stone-300 shrink-0" />
                  )}
                  <span className={!f.free ? 'text-stone-400' : ''}>{f.name}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={onStartClick}
              className="w-full bg-stone-900 text-white py-3 rounded-full font-semibold hover:bg-stone-700 transition"
            >
              Haz la primera pregunta
            </button>
          </div>

          {/* Book plan */}
          <div className="rounded-2xl border-2 border-rose-200 p-6 md:p-8 bg-rose-50/30 relative">
            <div className="absolute -top-3 right-6 bg-rose-500 text-white text-xs font-bold px-3 py-1 rounded-full">
              Próximamente
            </div>
            <h3 className="text-xl font-semibold text-stone-900 mb-1">Libro</h3>
            <p className="text-stone-500 text-sm mb-6">Precio por definir</p>

            <ul className="space-y-4 mb-8">
              {features.map((f, i) => (
                <li key={i} className="flex items-center gap-3 text-sm text-stone-700">
                  <Check size={18} className="text-emerald-500 shrink-0" />
                  <span>{f.name}</span>
                </li>
              ))}
            </ul>

            <button
              disabled
              className="w-full bg-stone-200 text-stone-500 py-3 rounded-full font-semibold cursor-not-allowed"
            >
              Próximamente
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
